import * as React from 'react';

function HelpIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#CED4DA" />
      <g filter="url(#filter0_d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.755 8.45493C6.755 7.41993 7.475 6.92493 8.075 6.48993C8.54 6.15993 8.945 5.87493 8.945 5.42493C8.945 4.95993 8.6 4.56993 7.775 4.56993C7.25 4.56993 6.815 4.73493 6.44 5.04993C6.305 5.13993 6.11 5.19993 5.93 5.19993C5.42 5.19993 5 4.79493 5 4.28493C5 3.95493 5.165 3.68493 5.405 3.51993C6.155 2.96493 7.04 2.67993 8 2.67993C9.935 2.67993 11.12 3.65493 11.12 5.04993C11.12 6.29493 10.31 6.89493 9.605 7.38993C9.095 7.77993 8.615 8.10993 8.615 8.63493C8.615 8.67993 8.615 8.72493 8.63 8.78493C8.645 8.84493 8.63 8.88993 8.63 8.91993C8.585 9.35493 8.195 9.74493 7.73 9.74493C7.34 9.74493 6.995 9.47493 6.905 9.11493C6.8 8.90493 6.755 8.67993 6.755 8.45493ZM6.755 11.7849C6.755 11.1249 7.31 10.5699 7.97 10.5699C8.63 10.5699 9.185 11.1249 9.185 11.7849C9.185 12.4449 8.63 12.9999 7.97 12.9999C7.31 12.9999 6.755 12.4449 6.755 11.7849Z"
          fill="white" />
      </g>
      <defs>
        <filter id="filter0_d" x="4" y="1.67993" width="8.12" height="12.32" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default React.memo(HelpIcon);
